module.exports = __webpack_public_path__ + "img/jianjie (5).1068e568.png";